import React from 'react'
import ChatConversation from './ChatConversation'
import ChatMessageInput from '../atoms/ChatMessageInput'
import { useSelector } from 'react-redux';

const WorkspaceChats = () => {
    const { workspaceChat } = useSelector((state: any) => state.workspaces);
    if (!workspaceChat) return (
        <p>Loading ...</p>
    )
    return (
        <div className="flex !justify-end flex-col min-h-full">
            <ChatConversation />
            <ChatMessageInput />
        </div>
    )
}

export default WorkspaceChats